import moment from "moment";
import ReactDatePicker from "react-datepicker"

interface IYearCalendarProps {
  date: string | null | undefined;
  onChange: (date: string | null) => void;
}

const YearContent = (year: number) => {
  return <div className="px-2 py-2">{year}</div>;
};

export const YearCalendar = ({ date, onChange}: IYearCalendarProps) => {
  return (
    <ReactDatePicker
      selected={date ? moment(`${date}-01-01`).toDate() : null}
      onChange={(date) => {
        onChange(moment(date).format("YYYY"));
      }}
      calendarStartDay={1}
      calendarClassName="!border-0"
      inline
      disabledKeyboardNavigation
      showYearPicker={true}
      renderYearContent={YearContent}
    />
  )
}